/* eslint-disable jsx-a11y/label-has-associated-control */
import { Radio } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BsFillCalendarDateFill } from 'react-icons/bs'
import { FaRunning } from 'react-icons/fa'
import { GiBinoculars } from 'react-icons/gi'
import { useDispatch, useSelector } from 'react-redux'
import { setResearchStatus } from '../../../../../../redux/reducers/talentSlice'
import * as s from './SearchStatus.styles'

const propTypes = {
  required: PropTypes.bool,
}
const defaultProps = {
  required: false,
}

/**
 * Allows user to update his search status
 */
function SearchStatus({ required }) {
  const dispatch = useDispatch()
  const { researchStatus } = useSelector((state) => state.talent)
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })
  return (
    <s.SearchStatusWrapper>
      <label className="field-label label-research-status">
        {t('common:candidates.searchStatus.placeholder')}
        {required && <span className="required">*</span>}
      </label>
      <Radio.Group
        onChange={(e) => {
          const { value } = e.target
          dispatch(setResearchStatus(value))
        }}
        buttonStyle="solid"
        className="research-status-group"
        value={researchStatus}
      >
        <Radio.Button
          className="research-status-btn"
          value="active-search"
          data-cy="active-search"
        >
          <span className="border-icons">
            <FaRunning size={50} color="var(--border)" />
          </span>
          {t('common:candidates.searchStatus.activeSearch')}
        </Radio.Button>
        <Radio.Button value="listening-market" data-cy="listening-market-radio">
          <span className="border-icons">
            <BsFillCalendarDateFill size={50} color="var(--border)" />
          </span>
          {t('common:candidates.searchStatus.listeningMarket')}
        </Radio.Button>
        <Radio.Button value="not-interested" data-cy="not-interested-radio">
          <span className="border-icons">
            <GiBinoculars size={50} color="var(--border)" />
          </span>
          {t('common:candidates.searchStatus.notInterested')}
        </Radio.Button>
      </Radio.Group>
    </s.SearchStatusWrapper>
  )
}

SearchStatus.propTypes = propTypes
SearchStatus.defaultProps = defaultProps

export default SearchStatus
